"use client";

import TherapistsPublicTimeslots from "../therapist/therapists-public-timeslots";
import { type RouterOutput } from "~/server/api/root";
import { TherapySessionPurpose } from "~/prisma/browser";
import { useSession } from "next-auth/react";
import { Alert, AlertTitle, AlertDescription } from "../ui/alert";
import { capturePostHogEvent } from "~/lib/posthog/client";

interface StepTimeProps {
  userId: string;
  therapist?: NonNullable<RouterOutput["therapistRouter"]["getTherapist"]>;
  sessionPurpose: TherapySessionPurpose;
}

export default function StepTime(props: StepTimeProps) {
  const session = useSession();

  const handleDateTimeSelect = (dateTime: Date) => {
    capturePostHogEvent(
      props.sessionPurpose === TherapySessionPurpose.INTRO_CALL
        ? "intro_call_time_selected"
        : "time_slot_selected",
      {
        therapist_user_id: props.userId,
        therapist_id: props.therapist?.id,
        selected_day_of_week: dateTime.getDay(),
        selected_hour: dateTime.getHours(),
      },
    );
  };

  if (session.data?.user.role === "THERAPIST") {
    return (
      <div>
        <Alert>
          <AlertTitle>Terapeuti ne mogu zakazati sesiju</AlertTitle>
          <AlertDescription>
            Da bi zakazao/la sesiju, moraš biti prijavljen/a kao klijent.
          </AlertDescription>
        </Alert>
      </div>
    );
  }

  return (
    <TherapistsPublicTimeslots
      therapistUserId={props.userId}
      therapist={props.therapist}
      sessionPurpose={props.sessionPurpose}
      onDateTimeSelect={handleDateTimeSelect}
    />
  );
}
